<template>
  <v-list two-line subheader>
    <v-subheader>Utilità</v-subheader>

<!--     <v-list-item link :disabled="rigaDescrittiva" @click="menuClick('utility_sconti')">
      <v-list-item-icon><v-icon>mdi-calculator</v-icon></v-list-item-icon>              
      <v-list-item-content>
        <v-list-item-title>Modifica prezzi e sconti</v-list-item-title>
        <v-list-item-subtitle>Prezzi netti, lodri e sconti applicati</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>  
 -->

    <v-list-item link :disabled="disableHistory" @click="menuClick('utility_storico')">
      <v-list-item-icon><v-icon>mdi-clipboard-text-clock-outline</v-icon></v-list-item-icon>              
      <v-list-item-content>
        <v-list-item-title>Storico e dettagli</v-list-item-title>
        <v-list-item-subtitle>Valori prezzi prodotto e storico degli acquisti</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item link :disabled="disableHistory" @click="menuClick('utility_etichette')">
      <v-list-item-icon><v-icon>mdi-card-bulleted-outline</v-icon></v-list-item-icon>              
      <v-list-item-content>
        <v-list-item-title>Stampa etichette</v-list-item-title>
        <v-list-item-subtitle>Stampa le etichette per il prodotto</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>    
<!--     <v-list-item link :disabled="disableHistory" @click="menuClick('utility_calcolati')">
      <v-list-item-icon><v-icon>mdi-clipboard-text-clock-outline</v-icon></v-list-item-icon>              
      <v-list-item-content>
        <v-list-item-title>Campi calcolati</v-list-item-title>
        <v-list-item-subtitle>Mostra / nascondi i campi calcolati</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>    -->
    <v-divider></v-divider>
    <v-subheader>Spostamenti</v-subheader>
    <v-list-item link :disabled="index === 0" @click="menuClick('move_top')">
      <v-list-item-icon><v-icon>mdi-arrow-collapse-up</v-icon></v-list-item-icon>              
      <v-list-item-content>
        <v-list-item-title>Sposta inizio</v-list-item-title>
        <v-list-item-subtitle>Sposta la riga all'inizio del documento</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item link :disabled="index === 0" @click="menuClick('move_up')">
      <v-list-item-icon><v-icon>mdi-arrow-up</v-icon></v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>Sposta su</v-list-item-title>
        <v-list-item-subtitle>Sposta la riga in alto di una posizione</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item link :disabled="index === rowsNumber - 1" @click="menuClick('move_down')">
      <v-list-item-icon><v-icon>mdi-arrow-down</v-icon></v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>Sposta giù</v-list-item-title>
        <v-list-item-subtitle>Sposta la riga in basso di una posizione</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item> 
    <v-list-item link :disabled="index === rowsNumber - 1" @click="menuClick('move_bottom')">
      <v-list-item-icon><v-icon>mdi-arrow-collapse-down</v-icon></v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>Sposta fine</v-list-item-title>
        <v-list-item-subtitle>Sposta la riga alla fine del documento</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
  import _ from 'lodash'
  export default {
    props: {
      item: Object,
      index: Number,
      rowsNumber: Number
    },
    computed: {
      disableHistory() {
        const rigaDescrittiva = _.get(this.item, 'appoggio.rigaDescrittiva', false)
        const codiceProdotto = _.get(this.item, 'prodotto.codice', null)
        return rigaDescrittiva || (codiceProdotto === null)
      }
    },
    methods: {
      menuClick(command) {
        this.$emit("click", { command, index: this.index })
      }
    }
  }
</script>